"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Return color from pallete
 * @param {String} color
 * @param {String} shade
 * @param {String} defaultColor
 * @returns {String}
 */
var getThemeColor = function getThemeColor(color, shade) {
  var defaultColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return function (props) {
    if (!color) {
      return defaultColor;
    }

    if (!props.theme[color]) {
      return defaultColor;
    }

    if (!props.theme[color][shade]) {
      return defaultColor;
    }

    return props.theme[color][shade];
  };
};

var _default = getThemeColor;
exports["default"] = _default;